export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13213.3f9bc607.jpg";